import request from '@/config/axios'

/** 用户信息（对应 dzh-app GET /txn/member/get 的返回） */
export interface UserInfo {
  id: number
  username?: string
  nickname?: string
  email?: string
  mobile?: string
  sex?: number
  avatar?: string
  loginIp?: string
  loginDate?: number
  createTime?: number
  brokerBindFlag?: boolean
  brokerId?: number
  brokerBindTime?: number
  brokerAuthFlag?: boolean
  brokerAuthTime?: number
  /** 是否拥有已认证的企业（dzh-app /txn/member/get 直接返回，无需再循环企业列表） */
  hasVerifiedCompany?: boolean
}

/** 获取当前登录用户信息 */
export const getUserInfo = () =>
  request.get<UserInfo>({ url: '/txn/member/get' })
